import { useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useNavigate } from 'react-router-dom';

import { CookieValues } from '../../types';

function Logout() {
  const [, setCookie] = useCookies<'token' | 'user', CookieValues>(['token', 'user']);

  const navigate = useNavigate();

  useEffect(() => {
    setCookie('token', '');
    setCookie('user', '');

    navigate('/login');
        /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, []);

  return null;
}

export default Logout;
